'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';

import { NotFound } from '@/components/Error/NotFound';
import { featureFlags } from '@/lib/env';

export const Route = createFileRoute('/_individual/individual/portal')({
  component: PortalLayout,
});

function PortalLayout() {
  if (!featureFlags.check('LABOR_PLUS_MOCK')) {
    return <NotFound />;
  }

  return <Outlet />;
}
